var Handlebars = require("../../../../../handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return "<li class=\"sda-target\" data-uuid=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.uuid : stack1), depth0))
    + "\" data-url=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.url : stack1), depth0))
    + "\" data-affiliate=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.affiliate : stack1), depth0))
    + "\" data-city=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.city : stack1), depth0))
    + "\" data-state=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.state : stack1), depth0))
    + "\" data-name=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.name : stack1), depth0))
    + "\" data-dma=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.designatedMarketArea : stack1), depth0))
    + "\" data-call-letters=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.callLetters : stack1), depth0))
    + "\">\n    <a class=\"targeting-target\">\n        <div class=\"targeting-target-status\"></div>\n        <div class=\"targeting-target-logo\"><img src=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.imageUrl : stack1), depth0))
    + "\"></div>\n        <div class=\"targeting-target-data\">\n            <div class=\"targeting-target-url\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.url : stack1), depth0))
    + "</div>\n            <div class=\"targeting-target-city\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.city : stack1), depth0))
    + ", "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.site : depth0)) != null ? stack1.state : stack1), depth0))
    + "</div>\n        </div>\n    </a>\n</li>\n";
},"useData":true});